import { render, staticRenderFns } from "./ArticleLineCard.vue?vue&type=template&id=c66dab86&scoped=true&"
import script from "./ArticleLineCard.vue?vue&type=script&lang=js&"
export * from "./ArticleLineCard.vue?vue&type=script&lang=js&"
import style0 from "./ArticleLineCard.vue?vue&type=style&index=0&id=c66dab86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c66dab86",
  null
  
)

export default component.exports